module.exports = __webpack_public_path__ + "leading-6c4625cedbc9b83eaed2.gif";